import { Component, OnInit } from '@angular/core';
import { companyInfo } from 'src/common';

@Component({
  selector: 'app-datenschutz',
  templateUrl: './datenschutz.component.html',
  styleUrls: ['./datenschutz.component.scss']
})
export class DatenschutzComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  public text= companyInfo;
}
